import { Icon, mergeStyles, Stack } from '@fluentui/react';
import { IDynamicPerson, MgtTemplateProps, People } from '@microsoft/mgt-react';
import { observer } from 'mobx-react';

import React from 'react';
import PersonListState from '../../state/PersonListState';

export interface IPeopleListProps {
	state: PersonListState;
}

const PersonTemplate = (props: MgtTemplateProps) => {
	const person = props.dataContext.person as IDynamicPerson;

	return (
		<div>
			<strong>{person.displayName}</strong>
			<br />
			{(person as any).mail}
		</div>
	);
};

const iconClass = mergeStyles({
	fontSize: 18,
	height: 20,
	width: 20,
	margin: '18px',
	cursor: 'pointer',
});

class PeopleList extends React.Component<IPeopleListProps> {
	public render() {
		return <div>{this.props.state.ids.map((id) => this.getPersonRow(id))}</div>;
	}

	private getPersonRow(id: string): any {
		return (
			<Stack
				key={'person-' + id}
				horizontal
				style={{
					backgroundColor: 'white',
					borderRadius: '6px',
					margin: '10px',
				}}
			>
				<Stack.Item>
					<div style={{ marginTop: '4px' }}>
						<People userIds={[id]}></People>
					</div>
				</Stack.Item>

				<Stack.Item grow>
					<div style={{ marginLeft: '12px' }}>
						<People userIds={[id]}>
							<PersonTemplate template="person"></PersonTemplate>
						</People>
					</div>
				</Stack.Item>

				<Stack.Item>
					{this.props.state.canDelete(id) ? (
						<Icon
							title="Remove this user"
							onClick={() => {
								this.props.state.remove(id);
							}}
							iconName="Delete"
							className={iconClass}
						></Icon>
					) : (
						<Icon
							title="You cannot remove yourself."
							iconName="Info"
							className={iconClass}
						></Icon>
					)}
				</Stack.Item>
			</Stack>
		);
	}
}

export default observer(PeopleList);
